import { useEffect } from 'react';

export function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: () => void,
  ignoredRef?: React.RefObject<HTMLElement>
) {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      const target = event.target as Node;

      if (
        !ref.current ||
        ref.current.contains(target) ||
        (ignoredRef?.current && ignoredRef.current.contains(target))
      ) {
        return;
      }

      handler();
    };

    document.addEventListener('mousedown', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handler, ignoredRef]);
}
